import React from "react";
import styles from "components/upload-documents/processing-viewer.scss";
import { documentPropType } from "custom-prop-types";
import { isValidValue } from "utils/validators";

export const ProcessingViewer = ({ focusedDocument }) => {
  if (isValidValue(focusedDocument) && isValidValue(focusedDocument.attachment)) {
    return <iframe className={ `${styles.framer} manual5` } src={ focusedDocument.attachment.url } />;
  }
  return null;
};

ProcessingViewer.defaultProps = {
  focusedDocument: null
};

ProcessingViewer.propTypes = {
  focusedDocument: documentPropType
};



// WEBPACK FOOTER //
// ./src/js/components/upload-documents/processing-viewer.jsx